import { render, staticRenderFns } from "./DisbursementsTab.vue?vue&type=template&id=184459db&scoped=true"
import script from "./DisbursementsTab.vue?vue&type=script&lang=js"
export * from "./DisbursementsTab.vue?vue&type=script&lang=js"
import style0 from "./DisbursementsTab.vue?vue&type=style&index=0&id=184459db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184459db",
  null
  
)

export default component.exports